/**
 * ランキングに出す呼び名。**自由入力はさせない**（荒らし・個人情報の書き込みを防ぐ）。
 * 決まった語の組み合わせ＋4桁の番号。サーバーも同じ表で検査する。
 * 前半・後半は本人が一覧から選べる（ランキングの「呼び名をえらぶ」）。番号は自動で付く。
 */

export const NAME_ADJECTIVES = [
  'はらぺこ',
  '食いしん坊の',
  '通りすがりの',
  '早起きの',
  '夜ふかしの',
  '屋台好きの',
  'のんびり',
  '旅する',
  'ご当地好きの',
  '腹八分の',
] as const;

export const NAME_NOUNS = ['旅人', '板前', '常連', '食通', '見習い', '女将', '大将', '店主', '味見係', '風来坊'] as const;

export function makeDailyName(rand: () => number = Math.random): string {
  const a = NAME_ADJECTIVES[Math.floor(rand() * NAME_ADJECTIVES.length)];
  const n = NAME_NOUNS[Math.floor(rand() * NAME_NOUNS.length)];
  const num = String(Math.floor(rand() * 10000)).padStart(4, '0');
  return `${a}${n}#${num}`;
}

export function isAllowedDailyName(name: string): boolean {
  const m = /^(.+)#(\d{4})$/.exec(name);
  if (!m) return false;
  return NAME_ADJECTIVES.some((a) => NAME_NOUNS.some((n) => `${a}${n}` === m[1]));
}

export type NameAdjective = (typeof NAME_ADJECTIVES)[number];
export type NameNoun = (typeof NAME_NOUNS)[number];

/** 前半・後半・番号から呼び名を作る。一覧にない語なら null。 */
export function composeDailyName(adjective: string, noun: string, number: string): string | null {
  if (!(NAME_ADJECTIVES as readonly string[]).includes(adjective)) return null;
  if (!(NAME_NOUNS as readonly string[]).includes(noun)) return null;
  if (!/^\d{4}$/.test(number)) return null;
  return `${adjective}${noun}#${number}`;
}

/** 呼び名を前半・後半・番号に分ける（選ぶ画面の初期値に使う）。分けられなければ null。 */
export function splitDailyName(name: string): { adjective: NameAdjective; noun: NameNoun; number: string } | null {
  const m = /^(.+)#(\d{4})$/.exec(name);
  if (!m) return null;
  for (const adjective of NAME_ADJECTIVES) {
    for (const noun of NAME_NOUNS) {
      if (`${adjective}${noun}` === m[1]) return { adjective, noun, number: m[2] };
    }
  }
  return null;
}

/** 4桁の番号（自動）。 */
export function randomNameNumber(rand: () => number = Math.random): string {
  return String(Math.floor(rand() * 10000)).padStart(4, '0');
}
